module.exports = __webpack_public_path__ + "img/8f79efe.png";